import { render, staticRenderFns } from "./purchase-incentive.vue?vue&type=template&id=9a4ff234&scoped=true&"
import script from "./purchase-incentive.vue?vue&type=script&lang=js&"
export * from "./purchase-incentive.vue?vue&type=script&lang=js&"
import style0 from "./purchase-incentive.vue?vue&type=style&index=0&id=9a4ff234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4ff234",
  null
  
)

export default component.exports